/* eslint-disable camelcase */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  Button,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  DialogTitle,
  Box,
  Typography,
  TextField,
  FormControl,
  RadioGroup,
  FormControlLabel,
} from '@material-ui/core';
import { NavigateNext } from '@material-ui/icons';
import {
  setTradeInfoPopFlg,
  setTradeInfoCondition,
  setTradeInfoSearchItemList,
  setTradeInfoSearchItem,
  getTradeInfoMaster,
  setCheckTradeInfoSearchValue,
  setTradeInfoAddCondition,
  setErrMsgTradeInfoSearchValue,
  setCheckTradeInfoLimit,
  setErrMsgTradeInfoLimit,
  setErrMsgTradeInfoRequired,
  setGetTradeInfoFlg,
} from '../../actions/TargetAction';
import styles from './PopStyles.module.css';
import {
  CONTRACT_LABEL,
  TRADE_CONDITION_RADIO,
  TARGET_TRADE_DIVISION_CODE,
  ADD_LIMIT_COUNT,
  GET_MASTER_FLG,
} from '../../../common/const';
import validator from '../../../common/validator';
import { ERROR } from '../../../common/message';
import { getMessage } from '../../../common/util';
import CustomRadio from '../common/CustomRadio';

class TargetPopTradeInfoComponent extends Component {
  componentDidMount = async () => {
    const {
      setTradeInfoSearchItemListAct,
      getTradeInfoMasterAct,
      setTradeInfoAddConditionAct,
      tradeInfoPopFlg,
      getTradeInfoFlg,
      tradeInfoCondition,
      setTradeInfoConditionAct,
      setGetTradeInfoFlgAct,
    } = this.props;

    // お客様取引情報検索項目の取得
    const retTradeSearch = await getTradeInfoMasterAct(TARGET_TRADE_DIVISION_CODE.SEARCH);
    if (retTradeSearch) {
      setTradeInfoSearchItemListAct(retTradeSearch);
    }

    if (tradeInfoPopFlg && getTradeInfoFlg === GET_MASTER_FLG.ON) {
      // 項目名をobjectに格納
      const tradeInfoList = [];
      tradeInfoCondition.forEach((tradeInfo) => {
        const tradeInfoSearchItemName = retTradeSearch.additional_list.map((item) => {
          if (item.item_code === tradeInfo.item_code) {
            // 一致したら項目名を保持
            return item.item_name;
          }
          return null;
        });

        const item = {
          item_code: tradeInfo.item_code,
          item_name: tradeInfoSearchItemName,
          item_value: tradeInfo.item_value,
          search_type: tradeInfo.search_type,
          length_error: false,
          required_error: false,
        };
        tradeInfoList.push(item);
      });

      setTradeInfoConditionAct(tradeInfoList);
      setTradeInfoAddConditionAct(tradeInfoList);
      setGetTradeInfoFlgAct(GET_MASTER_FLG.OFF);
    }
  }

  /**
   * 取引情報選択POPUPをclose
   */
  closeTradeInfoPop = () => {
    const { setTradeInfoPopFlgAct } = this.props;
    setTradeInfoPopFlgAct(false);
  };

  /**
   * 取引情報条件を削除
   */
  deleteTradeInfoCondition = (index) => {
    const {
      tradeInfoAddCondition,
      setTradeInfoAddConditionAct,
      setErrMsgTradeInfoLimitAct,
    } = this.props;

    // エラーメッセージ初期化
    setErrMsgTradeInfoLimitAct();

    const newTradeInfoAddCondition = tradeInfoAddCondition.filter((_, i) => i !== index);
    setTradeInfoAddConditionAct(newTradeInfoAddCondition);
  }

  /**
   * 項目値変更
   */
  changeType = (index, type) => {
    const {
      tradeInfoAddCondition,
      setTradeInfoAddConditionAct,
    } = this.props;

    const copyTradeInfoAddCondition = [...tradeInfoAddCondition];
    copyTradeInfoAddCondition[index].search_type = type;
    setTradeInfoAddConditionAct(copyTradeInfoAddCondition);
  }

  /**
   * 精度変更
   */
  changeValue = (index, val) => {
    const {
      tradeInfoAddCondition,
      setTradeInfoAddConditionAct,
    } = this.props;

    const copyTradeInfoAddCondition = [...tradeInfoAddCondition];
    copyTradeInfoAddCondition[index].item_value = val;
    setTradeInfoAddConditionAct(copyTradeInfoAddCondition);
  }

  /**
   * 追加ボタン押下
   */
  addCondition = (index) => {
    const {
      tradeInfoAddCondition,
      setTradeInfoAddConditionAct,
      setErrMsgTradeInfoLimitAct,
    } = this.props;

    if (tradeInfoAddCondition.length >= ADD_LIMIT_COUNT.TRADE) {
      setErrMsgTradeInfoLimitAct(getMessage(ERROR.E02005));
      return;
    }

    const copyTradeInfoAddCondition = [...tradeInfoAddCondition];

    const addItem = {
      item_code: index.item_code,
      item_name: index.item_name,
      item_value: '',
      search_type: TRADE_CONDITION_RADIO.CONDITION_EXACT,
      length_error: false,
      required_error: false,
    };

    copyTradeInfoAddCondition.push(addItem);

    setTradeInfoAddConditionAct(copyTradeInfoAddCondition);
  }

  /**
   * キャンセルボタン押下
   */
  cancel = () => {
    const {
      setErrMsgTradeInfoLimitAct,
      setCheckTradeInfoSearchValueAct,
      setErrMsgTradeSearchValueAct,
      setErrMsgTradeInfoRequiredAct,
    } = this.props;

    // 初期化
    setErrMsgTradeInfoLimitAct();
    setCheckTradeInfoSearchValueAct(false);
    setErrMsgTradeSearchValueAct();
    setErrMsgTradeInfoRequiredAct();

    // ポップアップを閉じる
    this.closeTradeInfoPop();
  };

  /**
   * 設定ボタン押下
   */
  setCondition = () => {
    const {
      tradeInfoAddCondition,
      setTradeInfoConditionAct,
      setErrMsgTradeInfoLimitAct,
      setErrMsgTradeInfoRequiredAct,
      setCheckTradeInfoSearchValueAct,
      setTradeInfoAddConditionAct,
    } = this.props;

    const copyTradeInfoAddCondition = [...tradeInfoAddCondition];

    tradeInfoAddCondition.forEach((tradeInfo, index) => {
      if (!tradeInfo.item_value) {
        copyTradeInfoAddCondition[index].required_error = true;
      } else {
        copyTradeInfoAddCondition[index].required_error = false;
      }
    });
    setTradeInfoAddConditionAct(copyTradeInfoAddCondition);

    if (copyTradeInfoAddCondition.some((item) => item.required_error)) {
      // エラー有りの場合
      // エラーメッセージ、エラーフラグを設定
      setErrMsgTradeInfoRequiredAct(getMessage(ERROR.E08001, '検索内容'));
      // setCheckTradeInfoSearchValueAct(true);
      // return;
    } else {
      setTradeInfoConditionAct(copyTradeInfoAddCondition);
      // 初期化
      setErrMsgTradeInfoRequiredAct();
      setErrMsgTradeInfoLimitAct();
      setCheckTradeInfoSearchValueAct(false);
      // ポップアップを閉じる
      this.closeTradeInfoPop();
    }
  }

  onBlurTradeInfoValue = (index) => {
    const {
      setCheckTradeInfoSearchValueAct,
      setErrMsgTradeSearchValueAct,
      tradeInfoAddCondition,
      setTradeInfoAddConditionAct,
      setErrMsgTradeInfoRequiredAct,
      errMsgTradeInfoSearchValue,
    } = this.props;

    // 入力チェック
    const msgs = [];
    validator.checkMaxLength(tradeInfoAddCondition[index].item_value, 255, msgs);
    const copyTradeInfoAddCondition = [...tradeInfoAddCondition];
    if (msgs.length !== 0) {
      copyTradeInfoAddCondition[index].length_error = true;
    } else {
      copyTradeInfoAddCondition[index].length_error = false;
    }

    if (copyTradeInfoAddCondition.some((tradeInfo) => tradeInfo.length_error)) {
      // エラー有りの場合
      // エラーメッセージ、エラーフラグを設定
      if (!errMsgTradeInfoSearchValue) {
        setCheckTradeInfoSearchValueAct(true);
        setErrMsgTradeSearchValueAct(getMessage(ERROR.E08009, msgs.join(',')));
      }
    } else {
      // エラー無しの場合
      // エラーメッセージ、エラーフラグを解除
      setErrMsgTradeSearchValueAct();
      setCheckTradeInfoSearchValueAct(false);
    }

    if (tradeInfoAddCondition[index].item_value) {
      copyTradeInfoAddCondition[index].required_error = false;
      if (copyTradeInfoAddCondition.every((tradeInfo) => !tradeInfo.required_error)) {
        // 必須エラー無しの場合、エラーメッセージを解除
        setErrMsgTradeInfoRequiredAct();
      }
    }

    setTradeInfoAddConditionAct(copyTradeInfoAddCondition);
  }

  render() {
    const {
      tradeInfoPopFlg,
      contractLabel,
      tradeInfoSearchItemList,
      checkErrFlg,
      tradeInfoAddCondition,
      errMsgTradeInfoSearchValue,
      errMsgTradeInfoLimit,
      errMsgTradeInfoRequired,
    } = this.props;

    const targetAdditionalCategory = contractLabel?.contract_label_list.filter(
      (i) => i?.label_code === CONTRACT_LABEL.TARGET_ADDITIONAL_CATEGORY,
    );

    const errMsgList = [];

    if (errMsgTradeInfoSearchValue
      || errMsgTradeInfoLimit
      || errMsgTradeInfoRequired) {
      if (errMsgTradeInfoLimit) errMsgList.push(errMsgTradeInfoLimit);
      if (errMsgTradeInfoRequired) errMsgList.push(errMsgTradeInfoRequired);
      if (errMsgTradeInfoSearchValue) errMsgList.push(errMsgTradeInfoSearchValue);
    }

    return (tradeInfoPopFlg && (
      <Box className={`${styles.dialog}`}>
        <Box className={`${styles.contents}`}>
          <Box className={`${styles.marginBottomHalf}`}>
            <DialogTitle className={`${styles.dialogTitle}`}>{targetAdditionalCategory ? targetAdditionalCategory[0]?.label : ''}</DialogTitle>
          </Box>
          <Box className={`${styles.height2} ${styles.tradeInfoMsgArea}`}>
            <span className={`${styles.tradeInfoErrorMsg}`}>
              {errMsgList.join(' ')}
            </span>
          </Box>
          <Box className={`${styles.height2} ${styles.tradeInfoMsgArea}`}>
            <span className={`${styles.tradeInfoMsg}`}>
              検索条件に利用したい項目を選択してください
            </span>
          </Box>
          <Box className={`${styles.tradeItemListArea}`}>
            <Box className={`${styles.searchResultareaTableHead}`}>
              <Table className={`${styles.tableLayoutFixed}`}>
                <TableHead>
                  <TableRow>
                    <TableCell className={`${styles.dialogTableHeader} ${styles.dialogTableCell} ${styles.searchResultareaHeader} ${styles.addDeleteCell}`}> </TableCell>
                    <TableCell className={`${styles.dialogTableHeader} ${styles.dialogTableCell} ${styles.searchResultareaHeader}`}>項目名</TableCell>
                  </TableRow>
                </TableHead>
              </Table>
            </Box>
            <Box className={`${styles.tradeItemListAreaTableBody}`}>
              <Table className={`${styles.tableLayoutFixed}`}>
                <TableBody>
                  {tradeInfoSearchItemList
                    && tradeInfoSearchItemList.additional_list
                    && tradeInfoSearchItemList.additional_list.map((tradeSearchList, i) => (
                      <TableRow key={i}>
                        <TableCell className={`${styles.dialogTableCell} ${styles.addDeleteCell}`}>
                          <Button
                            variant="contained"
                            className={`${styles.tooltip} addDelete`}
                            onClick={() => this.addCondition(tradeSearchList)}
                          >
                            <span>＋</span>
                            <Box className={`${styles.description}`}>検索条件に追加</Box>
                          </Button>
                        </TableCell>
                        <TableCell className={`${styles.dialogTableCell}`}>{tradeSearchList.item_name}</TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </Box>
          </Box>
          <Box className={`${styles.listSpacerArea}`}>
            <Box className={`${styles.tradeInfoArrowDownSpace}`}>
              <Typography className={`${styles.tradeInfoArrowDownIcon}`}>≫</Typography>
            </Box>
          </Box>
          <Box className={`${styles.tradeInfoCondition}`}>
            <Box className={`${styles.productsconditionTableHead}`}>
              <Table className={`${styles.tableLayoutFixed}`}>
                <TableHead>
                  <TableRow>
                    <TableCell className={`${styles.dialogTableHeader} ${styles.dialogTableCell} ${styles.conditionlistHeader} ${styles.addDeleteCell}`}> </TableCell>
                    <TableCell className={`${styles.dialogTableHeader} ${styles.dialogTableCell} ${styles.conditionlistHeader}`}>選択内容</TableCell>
                  </TableRow>
                </TableHead>
              </Table>
            </Box>
            <Box className={`${styles.tradeInfoConditionTableBody}`}>
              <Table className={`${styles.tableLayoutFixed}`}>
                <TableBody>
                  {tradeInfoAddCondition
                    && tradeInfoAddCondition.map((selectCondition, i) => (
                      <TableRow key={i}>
                        <TableCell className={`${styles.tradeInfoDialogTableCell} ${styles.addDeleteCell}`}>
                          <Button
                            variant="contained"
                            className={`${styles.tooltip} addDelete`}
                            onClick={() => this.deleteTradeInfoCondition(i)}
                          >
                            <span>－</span>
                            <Box className={`${styles.description}`}>検索条件から削除</Box>
                          </Button>
                        </TableCell>
                        <TableCell className={`${styles.tradeInfoDialogTableCell} ${styles.itemNameWidth}`}>
                          {selectCondition.item_name}
                        </TableCell>
                        <TableCell className={`${styles.tradeInfoDialogTableCell} ${styles.itemValueWidth}`}>
                          <TextField
                            className={`${styles.marginZero} ${styles.tradeInfoTextField}`}
                            variant="outlined"
                            margin="normal"
                            InputProps={{ classes: { input: styles.inputSizing } }}
                            value={selectCondition.item_value || ''}
                            onChange={(ev) => this.changeValue(i, ev.target.value)}
                            onBlur={() => this.onBlurTradeInfoValue(i)}
                            error={!!(selectCondition.length_error
                              || selectCondition.required_error)}
                            placeholder="検索内容を入力してください"
                          />
                        </TableCell>
                        <TableCell className={`${styles.tradeInfoDialogTableCell}`}>
                          <FormControl component="fieldset">
                            <RadioGroup row>
                              <FormControlLabel
                                value={TRADE_CONDITION_RADIO.CONDITION_EXACT}
                                control={<CustomRadio className={`${styles.tradeInfoRadio}`} />}
                                label="完全一致"
                                checked={
                                  selectCondition.search_type
                                  === TRADE_CONDITION_RADIO.CONDITION_EXACT
                                }
                                onChange={() => this.changeType(
                                  i, TRADE_CONDITION_RADIO.CONDITION_EXACT,
                                )}
                              />
                              <FormControlLabel
                                value={TRADE_CONDITION_RADIO.CONDITION_FORWARD}
                                control={<CustomRadio className={`${styles.tradeInfoRadio}`} />}
                                label="前方一致"
                                checked={
                                  selectCondition.search_type
                                  === TRADE_CONDITION_RADIO.CONDITION_FORWARD
                                }
                                onChange={() => this.changeType(
                                  i, TRADE_CONDITION_RADIO.CONDITION_FORWARD,
                                )}
                              />
                              <FormControlLabel
                                value={TRADE_CONDITION_RADIO.CONDITION_BACKWARD}
                                control={<CustomRadio className={`${styles.tradeInfoRadio}`} />}
                                label="後方一致"
                                checked={
                                  selectCondition.search_type
                                  === TRADE_CONDITION_RADIO.CONDITION_BACKWARD
                                }
                                onChange={() => this.changeType(
                                  i, TRADE_CONDITION_RADIO.CONDITION_BACKWARD,
                                )}
                              />
                              <FormControlLabel
                                value={TRADE_CONDITION_RADIO.CONDITION_PART}
                                control={<CustomRadio className={`${styles.tradeInfoRadio}`} />}
                                label="部分一致"
                                checked={
                                  selectCondition.search_type
                                  === TRADE_CONDITION_RADIO.CONDITION_PART
                                }
                                onChange={() => this.changeType(
                                  i, TRADE_CONDITION_RADIO.CONDITION_PART,
                                )}
                              />
                            </RadioGroup>
                          </FormControl>
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </Box>
          </Box>
          <Box className={`${styles.buttonArea}`}>
            <Button
              variant="contained"
              onClick={() => this.cancel()}
              className={`${styles.height2} cancel`}
            >
              キャンセル
            </Button>
            <Button
              variant="contained"
              color="secondary"
              className={`${styles.marginLeft1} ${styles.height2}`}
              onClick={() => this.setCondition()}
              disabled={checkErrFlg.checkTradeInfoSearchValue}
            >
              <NavigateNext className={`${styles.setButtonIcon}`} />
              設定
            </Button>
          </Box>

        </Box>
      </Box>
    ));
  }
}

export default connect(
  (state) => ({
    tradeInfoCondition: state.target.tradeInfoCondition,
    tradeInfoPopFlg: state.target.tradeInfoPopFlg,
    contractLabel: state.common.contractLabel,
    tradeInfoSearchItemList: state.target.tradeInfoSearchItemList,
    tradeInfoSearchItem: state.target.tradeInfoSearchItem,
    checkErrFlg: state.target.checkErrFlg,
    tradeInfoAddCondition: state.target.tradeInfoAddCondition,
    errMsgTradeInfoSearchValue: state.target.errMsgTradeInfoSearchValue,
    errMsgTradeInfoLimit: state.target.errMsgTradeInfoLimit,
    errMsgTradeInfoRequired: state.target.errMsgTradeInfoRequired,
    getTradeInfoFlg: state.target.getTradeInfoFlg,
  }),
  (dispatch) => ({
    setTradeInfoConditionAct: (obj) => dispatch(setTradeInfoCondition(obj)),
    setTradeInfoPopFlgAct: (bool) => dispatch(setTradeInfoPopFlg(bool)),
    setTradeInfoSearchItemListAct: (object) => dispatch(setTradeInfoSearchItemList(object)),
    setTradeInfoSearchItemAct: (str) => dispatch(setTradeInfoSearchItem(str)),
    getTradeInfoMasterAct: (divisionCode) => dispatch(getTradeInfoMaster(divisionCode)),
    setCheckTradeInfoSearchValueAct: (bool) => dispatch(setCheckTradeInfoSearchValue(bool)),
    setTradeInfoAddConditionAct: (obj) => dispatch(setTradeInfoAddCondition(obj)),
    setErrMsgTradeSearchValueAct: (sr) => dispatch(setErrMsgTradeInfoSearchValue(sr)),
    setCheckTradeInfoLimitAct: (bool) => dispatch(setCheckTradeInfoLimit(bool)),
    setErrMsgTradeInfoLimitAct: (str) => dispatch(setErrMsgTradeInfoLimit(str)),
    setErrMsgTradeInfoRequiredAct: (str) => dispatch(setErrMsgTradeInfoRequired(str)),
    setGetTradeInfoFlgAct: (bool) => dispatch(setGetTradeInfoFlg(bool)),
  }),
)(TargetPopTradeInfoComponent);
